import AuroraC1 from './Aurora C.webp'
import AuroraC2 from './Aurora C.webp'


const AuroraCimages =[
AuroraC1,AuroraC2
]

export default AuroraCimages;